import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Login';
import MainPage from './page/MainPage'; 
import Dashboard from './RevenueDashboard/Dashboard';
import StudentAdmin from './StudentRegister/StudentAdmin';
import ReceiptApp from './receipt/receipt'; // 1. Import คอมโพเนนต์ใบเสร็จ
import Timetable from './page/Timetable'; // Import Timetable component
import Payroll from './page/Payroll'; // Import Payroll component
import './theme.css'; // นำเข้า theme.css ที่นี่
import './App.css'; 
import { createTheme } from '@mui/material';

function App() {
  // State for authentication and user data
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);

  // Handle successful login
  const handleLoginSuccess = (data) => {
    setIsLoggedIn(true);
    setUserData(data);
  };

  // Handle logout
  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserData(null);
  };

  // MUI Theme
  const theme = createTheme({
    palette: {
      primary: {
        main: '#556cd6',
      },
      secondary: {
        main: '#19857b',
      },
      background: {
        default: '#f4f6f8',
      },
    },
    typography: {
      fontFamily: 'Sarabun, sans-serif',
    }
  });

  return (
    <BrowserRouter 
      future={{ 
        v7_startTransition: true, 
        v7_relativeSplatPath: true,
        v7_fetcherPersist: true,
        v7_normalizeFormMethod: true,
        v7_partialHydration: true,
        v7_skipActionErrorRevalidation: true,
      }}
    >
      <div className="App">
        <Routes>
          {/* Default Routes */}
          <Route 
            path="/login" 
            element={<Login onLoginSuccess={handleLoginSuccess} />} 
          />
          <Route 
            path="/main" 
            element={isLoggedIn ? <MainPage onLogout={handleLogout} userData={userData} /> : <Navigate to="/login" />}
          />
          <Route 
            path="/dashboard" 
            element={isLoggedIn ? <Dashboard /> : <Navigate to="/login" />}
          />
          <Route 
            path="/student-admin" 
            element={isLoggedIn ? <StudentAdmin /> : <Navigate to="/login" />}
          />
          
          <Route 
            path="/receipts" 
            element={isLoggedIn ? <ReceiptApp /> : <Navigate to="/login" />}
          />
          
          <Route 
            path="/timetable" 
            element={isLoggedIn ? <Timetable /> : <Navigate to="/login" />}
          />
          
          <Route 
            path="/payroll" 
            element={isLoggedIn ? <Payroll /> : <Navigate to="/login" />}
          />
          
          {/* Fallback route */}
          <Route 
            path="*"
            element={<Navigate to={isLoggedIn ? "/main" : "/login"} />}
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;

